import type { BadgeProps } from "@/components/ui/badge";
import type { JobApplicationStatus } from "@/domains/company/company/api/types";

const APPLICATION_STATUS = [
  "pending",
  "viewed",
  "approved",
  "rejected",
  "in_negotiation",
  "selected",
  "retired",
] as const satisfies JobApplicationStatus[];

export const APPLICANT_VISIBLE_STATUS = [
  "pending",
  "viewed",
  "approved",
  "rejected",
  "in_negotiation",
  "selected",
] as const satisfies JobApplicationStatus[];

const STATUS_TEXTS = {
  pending: "Nuova",
  viewed: "Vista",
  approved: "Idoneo",
  rejected: "Non idoneo",
  in_negotiation: "In Trattativa",
  selected: "Selezionato",
  retired: "Chiusa",
} as const satisfies Record<JobApplicationStatus, string>;

const STATUS_VARIANTS = {
  pending: "outline",
  viewed: "outline",
  approved: "light-green",
  rejected: "destructive",
  in_negotiation: "light-indigo",
  selected: "success",
  retired: "disabled",
} as const satisfies Record<JobApplicationStatus, BadgeProps["variant"]>;

const getApplicationStatusBadge = (status: JobApplicationStatus) => {
  return {
    text: STATUS_TEXTS[status],
    variant: STATUS_VARIANTS[status],
  };
};

export const PROPOSAL_STATE = [
  "scouted",
  "view",
  "accepted",
  "rejected",
  "expired",
] as const;

export type ProposalState = (typeof PROPOSAL_STATE)[number];

export {
  APPLICATION_STATUS,
  getApplicationStatusBadge,
  STATUS_TEXTS,
  STATUS_VARIANTS,
};
